var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back_to_top",style:({'--workshop-color': _vm.toolkit.color }),on:{"click":function($event){return _vm.backToTop()}}},[_vm._v("— "+_vm._s(_vm.$t('strings.backToTop'))+" —")])}
var staticRenderFns = []

export { render, staticRenderFns }